import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import GroupsForm from './group-form';
import BackLink from '../../../common/back-link';
import {destandard} from '../../../../utils/commonFunctions';
import {getGroup, saveGroup, updateGroup} from '../../../../actions/groups';
import PageTitle from '../../../common/page-title/index';
import {history} from '../../../../store';

const model = 'deep.admin_group_save';

class GroupsFormPage extends Component {
  handleSubmit = (payLoad) => {
    const {dispatch} = this.props;

    if (this.isEdit()) {
      dispatch(actions.submitFields(model, updateGroup(this.id, payLoad, dispatch)))
        .then(() => {
          history.push('/admin/groups');
        });
    } else {
      dispatch(actions.submitFields(model, saveGroup(payLoad, dispatch)))
        .then(() => {
          history.push('/admin/groups');
        });
    }
  };

  constructor(props) {
    super(props);
    this.id = this.props.match.params.id;
  }

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    if (this.isEdit()) {
      dispatch(getGroup(this.id))
        .then(() => {
          const data = destandard({
            ...this.props.group.attributes
          });

          dispatch(actions.load(model, data));
        });
    } else {
      dispatch(actions.reset(model));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset(model));
  }

  isEdit() {
    return this.id && parseInt(this.id);
  }

  render() {
    const {loading} = this.props;

    return (
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/groups"/>
          </Col>
        </Row>
        <PageTitle>
          Group
        </PageTitle>
        {loading && 'Loading...'}
        <GroupsForm
          model={model}
          onSubmit={this.handleSubmit.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  group: state.groups.group,
  loading: !state.groups.fetched && state.groups.fetching,
});

export default connect(mapStateToProps)(GroupsFormPage);
